export default __webpack_public_path__ + "static/media/Truck right.a020ae65.svg";